var _a;
import { EmailValidator } from 'commons-validator-js';
import { InputControlType } from '@wix/events-types';
var emailValidator = new EmailValidator();
export var REQUIRED_ERROR = 'formError.requiredError';
export var EMAIL_ERROR = 'formError.emailError';
export var PHONE_ERROR = 'formError.phoneError';
export var DATE_ERROR = 'formError.dateError';
var isValidDate = function (dateString) {
    var regEx = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateString.match(regEx)) {
        return false;
    }
    var d = new Date(dateString);
    var dNum = d.getTime();
    if (!dNum && dNum !== 0) {
        return false;
    }
    return d.toISOString().slice(0, 10) === dateString;
};
var isDateEmpty = function (value) { return !(value && value.replace(/-/g, '').replace('undefined', '')); };
export var required = function (value) {
    if (value === void 0) { value = ''; }
    return (typeof value === 'string' && value.trim() ? undefined : REQUIRED_ERROR);
};
export var arrRequired = function (value) { return (value && value.length ? undefined : REQUIRED_ERROR); };
export var email = function (value) {
    return !value ? REQUIRED_ERROR : emailValidator.isValid(value) ? undefined : EMAIL_ERROR;
};
export var phoneRequired = function (value) { return (!value ? REQUIRED_ERROR : phone(value)); };
export var phone = function (value) { return (!value || /^[0-9()+\-\s]{0,25}$/.test(value) ? undefined : PHONE_ERROR); };
export var fullAddressRequired = function (value) {
    var errors = [];
    for (var i = 0; i < 5; i++) {
        if (!value || !value[i]) {
            errors[i] = REQUIRED_ERROR;
        }
    }
    return errors.length ? errors : undefined;
};
export var shortAddressRequired = function (value) { return (value && value[0] ? undefined : [REQUIRED_ERROR]); };
export var dateRequired = function (value) { return (isDateEmpty(value) ? REQUIRED_ERROR : date(value)); };
export var date = function (value) { return (isDateEmpty(value) || isValidDate(value) ? undefined : DATE_ERROR); };
export var guestNamesRequired = function (value) {
    var _a, _b;
    var additionalGuests = (_a = value === null || value === void 0 ? void 0 : value.additionalGuests) !== null && _a !== void 0 ? _a : 0;
    var guestNames = (_b = value === null || value === void 0 ? void 0 : value.guestNames) !== null && _b !== void 0 ? _b : [];
    var errors = [];
    for (var i = 0; i < additionalGuests; i++) {
        if (!(guestNames[i] && guestNames[i].firstName)) {
            errors[i] = errors[i] || {};
            errors[i].firstName = REQUIRED_ERROR;
        }
        if (!(guestNames[i] && guestNames[i].lastName)) {
            errors[i] = errors[i] || {};
            errors[i].lastName = REQUIRED_ERROR;
        }
    }
    return errors.length ? errors : undefined;
};
export var FORM_FIELD_VALIDATION = {
    input: function (field) {
        if (field.name.includes('email')) {
            return email;
        }
        else if (field.name.includes('phone')) {
            return field.mandatory ? phoneRequired : phone;
        }
        else {
            return field.mandatory ? required : undefined;
        }
    },
    textarea: function (field) { return (field.mandatory ? required : undefined); },
    dropdown: function () { return undefined; },
    radio: function () { return undefined; },
    checkbox: function (field) { return (field.mandatory ? arrRequired : undefined); },
    address: function (field) { return (field.mandatory ? (field.full ? fullAddressRequired : shortAddressRequired) : undefined); },
    date: function (field) { return (field.mandatory ? dateRequired : date); },
    guestsControl: function (field) { return (field.requireGuestNames ? guestNamesRequired : undefined); },
};
export var NEW_FORM_FIELD_VALIDATION = (_a = {},
    _a[InputControlType.INPUT] = function (control) {
        if (control.name.includes('email')) {
            return email;
        }
        else if (control.name.includes('phone')) {
            return control.inputs[0].mandatory ? phoneRequired : phone;
        }
        else {
            return control.inputs[0].mandatory ? required : undefined;
        }
    },
    _a[InputControlType.TEXTAREA] = function (control) {
        return control.inputs[0].mandatory ? required : undefined;
    },
    _a[InputControlType.DROPDOWN] = function () { return undefined; },
    _a[InputControlType.RADIO] = function () { return undefined; },
    _a[InputControlType.CHECKBOX] = function (control) {
        return control.inputs[0].mandatory ? arrRequired : undefined;
    },
    _a[InputControlType.ADDRESS_FULL] = function (control) {
        return control.inputs[0].mandatory
            ? control.inputs[0].additionalLabels
                ? fullAddressRequired
                : shortAddressRequired
            : undefined;
    },
    _a[InputControlType.ADDRESS_SHORT] = function (control) {
        return control.inputs[0].mandatory
            ? control.inputs[0].additionalLabels
                ? fullAddressRequired
                : shortAddressRequired
            : undefined;
    },
    _a[InputControlType.DATE] = function (control) {
        return control.inputs[0].mandatory ? dateRequired : date;
    },
    _a[InputControlType.GUEST_CONTROL] = function (control) {
        return control.inputs[1].mandatory ? guestNamesRequired : undefined;
    },
    _a);
export var validate = function (values) { return ({
    firstName: required(values.firstName),
    lastName: required(values.lastName),
}); };
//# sourceMappingURL=form-validation.js.map